/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ConnectZoomApiBody } from '../models';
// @ts-ignore
import { GetZoomSetting200Response } from '../models';
// @ts-ignore
import { UpdateZoomSettingBody } from '../models';
/**
 * ZoomSettingApi - axios parameter creator
 * @export
 */
export const ZoomSettingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Zoom auth連携API
         * @summary Zoom auth連携API
         * @param {ConnectZoomApiBody} [connectZoomApiBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectZoomApi: async (connectZoomApiBody?: ConnectZoomApiBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/zoom/zoom_setting/connect_api`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectZoomApiBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zoom auth連携解除API
         * @summary Zoom auth連携解除API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectZoomApi: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/zoom/zoom_setting/disconnect_api`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zoom auth設定取得API
         * @summary Zoom auth設定取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoomSetting: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/zoom/zoom_setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zoom auth設定更新API
         * @summary Zoom auth設定更新API
         * @param {UpdateZoomSettingBody} [updateZoomSettingBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateZoomSetting: async (updateZoomSettingBody?: UpdateZoomSettingBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/zoom/zoom_setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateZoomSettingBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZoomSettingApi - functional programming interface
 * @export
 */
export const ZoomSettingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ZoomSettingApiAxiosParamCreator(configuration)
    return {
        /**
         * Zoom auth連携API
         * @summary Zoom auth連携API
         * @param {ConnectZoomApiBody} [connectZoomApiBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectZoomApi(connectZoomApiBody?: ConnectZoomApiBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectZoomApi(connectZoomApiBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Zoom auth連携解除API
         * @summary Zoom auth連携解除API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectZoomApi(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectZoomApi(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Zoom auth設定取得API
         * @summary Zoom auth設定取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZoomSetting(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetZoomSetting200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZoomSetting(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Zoom auth設定更新API
         * @summary Zoom auth設定更新API
         * @param {UpdateZoomSettingBody} [updateZoomSettingBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateZoomSetting(updateZoomSettingBody?: UpdateZoomSettingBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateZoomSetting(updateZoomSettingBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ZoomSettingApi - factory interface
 * @export
 */
export const ZoomSettingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ZoomSettingApiFp(configuration)
    return {
        /**
         * Zoom auth連携API
         * @summary Zoom auth連携API
         * @param {ConnectZoomApiBody} [connectZoomApiBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectZoomApi(connectZoomApiBody?: ConnectZoomApiBody, options?: any): AxiosPromise<void> {
            return localVarFp.connectZoomApi(connectZoomApiBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Zoom auth連携解除API
         * @summary Zoom auth連携解除API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectZoomApi(options?: any): AxiosPromise<void> {
            return localVarFp.disconnectZoomApi(options).then((request) => request(axios, basePath));
        },
        /**
         * Zoom auth設定取得API
         * @summary Zoom auth設定取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoomSetting(options?: any): AxiosPromise<GetZoomSetting200Response> {
            return localVarFp.getZoomSetting(options).then((request) => request(axios, basePath));
        },
        /**
         * Zoom auth設定更新API
         * @summary Zoom auth設定更新API
         * @param {UpdateZoomSettingBody} [updateZoomSettingBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateZoomSetting(updateZoomSettingBody?: UpdateZoomSettingBody, options?: any): AxiosPromise<void> {
            return localVarFp.updateZoomSetting(updateZoomSettingBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ZoomSettingApi - interface
 * @export
 * @interface ZoomSettingApi
 */
export interface ZoomSettingApiInterface {
    /**
     * Zoom auth連携API
     * @summary Zoom auth連携API
     * @param {ConnectZoomApiBody} [connectZoomApiBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomSettingApiInterface
     */
    connectZoomApi(connectZoomApiBody?: ConnectZoomApiBody, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Zoom auth連携解除API
     * @summary Zoom auth連携解除API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomSettingApiInterface
     */
    disconnectZoomApi(options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Zoom auth設定取得API
     * @summary Zoom auth設定取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomSettingApiInterface
     */
    getZoomSetting(options?: AxiosRequestConfig): AxiosPromise<GetZoomSetting200Response>;

    /**
     * Zoom auth設定更新API
     * @summary Zoom auth設定更新API
     * @param {UpdateZoomSettingBody} [updateZoomSettingBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomSettingApiInterface
     */
    updateZoomSetting(updateZoomSettingBody?: UpdateZoomSettingBody, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for connectZoomApi operation in ZoomSettingApi.
 * @export
 * @interface ZoomSettingApiConnectZoomApiRequest
 */
export interface ZoomSettingApiConnectZoomApiRequest {
    /**
     * 
     * @type {ConnectZoomApiBody}
     * @memberof ZoomSettingApiConnectZoomApi
     */
    readonly connectZoomApiBody?: ConnectZoomApiBody
}

/**
 * Request parameters for updateZoomSetting operation in ZoomSettingApi.
 * @export
 * @interface ZoomSettingApiUpdateZoomSettingRequest
 */
export interface ZoomSettingApiUpdateZoomSettingRequest {
    /**
     * 
     * @type {UpdateZoomSettingBody}
     * @memberof ZoomSettingApiUpdateZoomSetting
     */
    readonly updateZoomSettingBody?: UpdateZoomSettingBody
}

/**
 * ZoomSettingApi - object-oriented interface
 * @export
 * @class ZoomSettingApi
 * @extends {BaseAPI}
 */
export class ZoomSettingApi extends BaseAPI implements ZoomSettingApiInterface {
    /**
     * Zoom auth連携API
     * @summary Zoom auth連携API
     * @param {ZoomSettingApiConnectZoomApiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomSettingApi
     */
    public connectZoomApi(requestParameters: ZoomSettingApiConnectZoomApiRequest = {}, options?: AxiosRequestConfig) {
        return ZoomSettingApiFp(this.configuration).connectZoomApi(requestParameters.connectZoomApiBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zoom auth連携解除API
     * @summary Zoom auth連携解除API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomSettingApi
     */
    public disconnectZoomApi(options?: AxiosRequestConfig) {
        return ZoomSettingApiFp(this.configuration).disconnectZoomApi(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zoom auth設定取得API
     * @summary Zoom auth設定取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomSettingApi
     */
    public getZoomSetting(options?: AxiosRequestConfig) {
        return ZoomSettingApiFp(this.configuration).getZoomSetting(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zoom auth設定更新API
     * @summary Zoom auth設定更新API
     * @param {ZoomSettingApiUpdateZoomSettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomSettingApi
     */
    public updateZoomSetting(requestParameters: ZoomSettingApiUpdateZoomSettingRequest = {}, options?: AxiosRequestConfig) {
        return ZoomSettingApiFp(this.configuration).updateZoomSetting(requestParameters.updateZoomSettingBody, options).then((request) => request(this.axios, this.basePath));
    }
}
